// Helper para leer configuración desde config.json
interface AppConfig {
  SERVER_URL: string;
  USE_ADF_AUTH: boolean;
  AZURE_CLIENT_ID: string;
  AZURE_TENANT_ID: string;
  AZURE_REDIRECT_URI: string;
  AZURE_POST_LOGOUT_REDIRECT_URI: string;
  AZURE_SCOPES: string;
  AZURE_AD_SCOPES: string;
}

let cachedConfig: AppConfig | null = null;

export const getConfig = async (): Promise<AppConfig> => {
  if (cachedConfig) {
    return cachedConfig;
  }

  try {
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error(`Error al cargar configuración: ${response.status}`);
    }
    
    cachedConfig = await response.json();
    return cachedConfig as AppConfig;
  } catch (error) {
    console.error('Error cargando config.json:', error);
    
    // Fallback a valores por defecto si no se puede cargar config.json
    const fallbackConfig: AppConfig = {
      SERVER_URL: 'https://portal-evotestprl.evopreven.com',
      USE_ADF_AUTH: false,
      AZURE_CLIENT_ID: '',
      AZURE_TENANT_ID: '',
      AZURE_REDIRECT_URI: 'http://localhost:8200/callback',
      AZURE_POST_LOGOUT_REDIRECT_URI: 'http://localhost:8200/login',
      AZURE_SCOPES: 'User.Read,profile,email,openid',
      AZURE_AD_SCOPES: ''
    };
    
    cachedConfig = fallbackConfig;
    return fallbackConfig;
  }
};

// Función síncrona para obtener configuración (requiere que ya se haya cargado)
export const getConfigSync = (): AppConfig | null => {
  return cachedConfig;
};

// Función para invalidar cache (útil para pruebas o cambios dinámicos)
export const clearConfigCache = (): void => {
  cachedConfig = null;
};
